// extracted by mini-css-extract-plugin
module.exports = {"buttonCheckBox":"classes_buttonCheckBox__3sZ5t","questionFont":"classes_questionFont__32OHA"};